/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { IssuerWithInsiderTradingPlans } from '../models/issuer-with-insider-trading-plans';
import { InsiderTradingPlansFilters } from '../models/insider-trading-plans-filters';
@Injectable({
  providedIn: 'root',
})
class InsiderTradingPlansService extends __BaseService {
  static readonly getInsiderTradingPlansPath = '/insider/tradingPlans';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param filter undefined
   * @return returns a insider trading plans
   */
  getInsiderTradingPlansResponse(filter: InsiderTradingPlansFilters): __Observable<__StrictHttpResponse<IssuerWithInsiderTradingPlans>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/insider/tradingPlans`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<IssuerWithInsiderTradingPlans>;
      })
    );
  }
  /**
   * @param filter undefined
   * @return returns a insider trading plans
   */
  getInsiderTradingPlans(filter: InsiderTradingPlansFilters): __Observable<IssuerWithInsiderTradingPlans> {
    return this.getInsiderTradingPlansResponse(filter).pipe(
      __map(_r => _r.body as IssuerWithInsiderTradingPlans)
    );
  }
}

module InsiderTradingPlansService {
}

export { InsiderTradingPlansService }
